import TypedNativeModules from "../internal/TypedNativeModules";
import type { JSTLandingScreen } from "./JSTLandingScreen";

export default async function navigateTo(
  landingScreen: JSTLandingScreen,
  from: string | null,
): Promise<void> {
  await TypedNativeModules.RNJSTNavigator?.navigateTo?.(landingScreen, from);
}
